import React, { useState } from 'react'
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import ImageUpload from "../../../../Components/Form/ImageUpload/ImageUpload";
import { useForm, FormProvider } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Dropdown from "../../../../Components/Form/Dropdown/Dropdown";
import IdentityApi from "../../../../Api/IdentityApi";
import {getApiHost, getResponseError, getUserDetailsCookie, setUserDetailsCookie} from "../../../../Api/Utils/apiUtils";
import AutocompleteAddress from "../../../../Components/Form/AutocompleteAddress/AutocompleteAddress";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import { setUserActiveOnChat, setUserDeActiveOnChat } from '../../../../Api/Utils/chatUtils';
import { useEffect } from 'react';
import ContestPopup from '../../../../Components/ContestPopup/ContestPopup';
import { useDispatch, useSelector } from 'react-redux';
import { registerParticipantAction } from '../../../../Redux/Actions/registerParticipant.action';
import { finishVerificationContest } from '../../../../Redux/Actions/verifyContest.action';



const ProfileComponent = () => {
    const dispatch = useDispatch()
    const {
        heading,
        profilePic,
        userType,
        firstName,
        lastName,
        mobileNo,
        emailAddress,
        city,
        state,
        postalCode,
        updateButton
    } = formContent;

    
    const verifyContestData  = useSelector(state => state.verifyContestData)
    const { isValidContest, contestId } = verifyContestData

    const participant = useSelector(state => state.participant)
    const { isRegistared  } = participant



    const [isActivePopup, setisActivePopup] = useState(false)
    const [image, setImage] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const history = useHistory();

    useEffect(() => {
        const user = getUserDetailsCookie();
        setUserActiveOnChat(user.id)
        async function popUpChange() {
            if (isValidContest && contestId) {
                await dispatch(registerParticipantAction(contestId, user.id))
                setisActivePopup(isValidContest)
            }else if(isRegistared && isValidContest){
                setisActivePopup(isValidContest)
            }
            else{
                setisActivePopup(isValidContest)
            }
        }
        popUpChange()
    }, [contestId, isValidContest, dispatch, isRegistared]);
    
    const user = getUserDetailsCookie();
    setUserActiveOnChat(user.id)

    function resetTimer() {
        const user = getUserDetailsCookie()
        setUserActiveOnChat(user.id)
        setTimeout(() => {
            setUserDeActiveOnChat(user.id)
        }, 60000);
    }

    //set status
        window.onload = resetTimer;
        window.onmousemove = resetTimer;
        window.onmousedown = resetTimer;
        window.ontouchstart = resetTimer;
        window.onclick = resetTimer;
        window.onkeypress = resetTimer;
    
    if(user && user.imageUrl) {
        profilePic.defaultImage = getApiHost() +'/'+ user.imageUrl;
    }
    const formBinding = useForm({
        defaultValues: user
    });

    const submitForm = async (data) => {
        data.imageFile = image;
        data.socialType = '';
        const response = await IdentityApi.register(data);
        const apiError = getResponseError(response);
        if(apiError) {
            setErrorMessage(apiError);
        }else {
            const userDetails = response.objectVal.userResponse;
            setUserDetailsCookie(userDetails)
            const { isVerify } = userDetails;
            if(!isVerify) {
                history.push("/verify-otp");
            }
        }
    }
    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    async function setPopupClose() {
        await dispatch(finishVerificationContest())
    }

    return (
        <>
        {isActivePopup ? 
        <ContestPopup closeHandler={setPopupClose} />
        :
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="profile-form" onSubmit={handleSubmit(submitForm)}>
                        <ImageUpload {...profilePic} setImage={setImage}/>
                        <Dropdown {...userType}/>
                        <TextInput {...firstName} />
                        <TextInput {...lastName} />
                        <TextInput {...mobileNo} />
                        <TextInput {...emailAddress} />
                        <AutocompleteAddress {...city} />
                        <TextInput {...state} />
                        <TextInput {...postalCode} />
                        <Button {...updateButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>}
        </>
    )
}

export default ProfileComponent
